import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { EntitlementsService } from '../../Services/entitlements.service';
import { SharedService } from '../../Services/sharedService';

@Component({
  selector: 'app-feature-locked',
  templateUrl: './feature-locked.component.html',
  styleUrl: './feature-locked.component.css',
  standalone: false,
})
export class FeatureLockedComponent implements OnInit {
  featureLabels = '';
  returnUrl = '/dashboard';

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private entitlements: EntitlementsService,
    private sharedService: SharedService
  ) {
    this.sharedService.sideMenuSubject.next(true);
  }

  ngOnInit(): void {
    this.entitlements.syncFromSession();
    const keysParam = this.route.snapshot.queryParamMap.get('keys') ?? '';
    const keys = keysParam.split(',').map((k) => k.trim()).filter(Boolean);
    this.featureLabels = keys.length
      ? this.entitlements.getLabels(keys)
      : 'This feature';
    this.returnUrl =
      this.route.snapshot.queryParamMap.get('returnUrl') ?? '/dashboard';
  }

  goToPlans(): void {
    void this.router.navigate(['/billings'], { queryParams: { intent: 'upgrade' } });
  }

  goBack(): void {
    const target = this.returnUrl.startsWith('/') ? this.returnUrl : '/dashboard';
    this.router.navigateByUrl(target);
  }
}
